import Vue from 'vue'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import config from '@/config'

Sentry.init({
  environment: process.env.NODE_ENV,
  release: process.env.VUE_APP_RELEASE,
  dsn: config.sentryConfig.dsn,
  integrations: [new Integrations.Vue({
    Vue,
    attachProps: true,
    logErrors: process.env.NODE_ENV !== 'production',
  })],
})
